// Bumped on each release. Shown in sidebar footer.
export const FRONTEND_VERSION = 'v2.3.0'
export const BUILD_DATE = new Date().toISOString().slice(0, 10)
